import React, { useContext, useState } from 'react'
import { FiEye, FiPlusCircle, FiXCircle } from 'react-icons/fi'

import Spinner from '../../../components/Spinner'
import Table from '../../../components/Table'

import { api, authHeaders } from '../../../services/api'

import { Container } from './styles'
import FormExperiencia from '../../../components/FormExperiencia'
import Modal from '../../../components/Modal'
import { GlobalContext } from '../../../contexts/GlobalContext'
import { differenceInMonths, format } from 'date-fns'

export default function ({ pessoa, reload, editable = true }) {
	const { checkException } = useContext(GlobalContext)

	const [showForm, setShowForm] = useState(false)
	const [initialValues, setInitialValues] = useState(null)
	const [editId, setEditId] = useState(null)
	const [openedFile, setOpenedFile] = useState(null)
	const [mostrarAtividades, setMostrarAtividades] = useState(null)

	async function handlePrepareEdit(id) {
		if (!pessoa) {
			return
		}

		setEditId(id)

		const { atividades, inicio, fim, funcao, local } = pessoa.experiencias_profissionais
			.find(c => c.id === id) || null

		setInitialValues({
			local,
			funcao,
			atividades,
			inicio: format(new Date(inicio), 'dd/MM/yyyy'),
			fim: fim ? format(new Date(fim), 'dd/MM/yyyy') : ''
		})

		setShowForm(true)
	}

	async function handleDelete(id) {
		try {
			await api.delete(`pessoa_experiencia/${id}`, authHeaders())

			reload()

			return true
		} catch (e) {
			checkException(e)

			return false
		}
	}

	return (
		<>
			<Container className="animated fadeInUp delay-700ms">
				<h1>Experiências Profissionais</h1>

				{editable ? (
					<>
						{showForm ? (
							<FiXCircle
								size={24}
								data-tip="Fechar"
								data-for="tooltip"
								style={{ gridArea: 'icon' }}
								onClick={() => {
									setShowForm(false)
									setInitialValues(null)
									setEditId(null)
								}}
							/>
						) : (
							<FiPlusCircle
								size={24}
								data-tip="Adicionar"
								data-for="tooltip"
								style={{ gridArea: 'icon' }}
								onClick={() => {
									setShowForm(true)
								}}
							/>
						)}
					</>
				) : (
					<div />
				)}

				{showForm && (
					<FormExperiencia
						experienciaInitialValues={initialValues}
						editId={editId}
						pessoa={pessoa}
						style={{ gridArea: 'form' }}
						className="animated fadeIn"
						reload={() => {
							reload()
							setShowForm(false)
							setInitialValues(null)
							setEditId(null)
						}}
					/>
				)}

				{pessoa ? (
					<Table
						headers={[
							{ name: 'local', value: 'Local', centered: true },
							{ name: 'funcao', value: 'Função', centered: true },
							{ name: 'periodo', value: 'Período', centered: true }
						]}
						data={pessoa?.experiencias_profissionais?.map(item => {
							let tempoDeAtividade = differenceInMonths(item.fim ? new Date(item.fim) : new Date(), new Date(item.inicio))

							if(tempoDeAtividade < 1) {
								tempoDeAtividade = 'menos de 1 mês'
							} else if(tempoDeAtividade > 12) {
								const anos = Math.floor(tempoDeAtividade / 12)

								const meses = tempoDeAtividade % 12

								tempoDeAtividade = `${anos} anos e ${meses} meses`
							} else {
								tempoDeAtividade += ' meses'
							}

							return {
								...item,
								periodo: `${format(new Date(item.inicio), 'dd/MM/yyyy')} até ${item.fim ? format(new Date(item.fim), 'dd/MM/yyyy') : 'hoje'} (${tempoDeAtividade})`
							}
						}) || []}
						handlePrepareEdit={editable && handlePrepareEdit}
						handleDelete={editable && handleDelete}
						confirmExclusion={{
							template: 'Deseja realmente excluir este item?'
						}}
						emptyLabel="Nenhuma experiência adicionada"
						actions={[
							{
								name: 'visualizar atividades',
								action: setMostrarAtividades,
								icon: FiEye,
								iconSize: 16
							}
						]}
					/>
				) : (
					<Spinner />
				)}
			</Container>

			<Modal
				isOpen={!!openedFile}
				handleClose={() => {
					setOpenedFile(null)
				}}
				title="Visualização"
			>
				<img src={openedFile} alt="" className="w-full" />
			</Modal>

			<Modal
				isOpen={!!mostrarAtividades}
				handleClose={() => {
					setMostrarAtividades(null)
				}}
				title="Atividades de experiência profissional"
			>
				{mostrarAtividades && (
					<div>
						<div className="mx-2 mt-4">
							<span className="font-bold">{'Local: '}</span>
							{mostrarAtividades.local}
						</div>

						<div className="mx-2 mt-4">
							<span className="font-bold">{'Função: '}</span>
							{mostrarAtividades.funcao}
						</div>

						<div className="mx-2 mt-4">
							<span className="font-bold">{'Período: '}</span>
							{`${format(new Date(mostrarAtividades.inicio), 'dd/MM/yyyy')} até ${mostrarAtividades.fim ? format(new Date(mostrarAtividades.fim), 'dd/MM/yyyy') : 'hoje'}`}
						</div>

						<div className="mx-2 mt-4">
							<span className="font-bold">{'Atividades: '}</span>
							{mostrarAtividades.atividades}
						</div>
					</div>
				)}
			</Modal>
		</>
	)
}
